export default __webpack_public_path__ + "static/media/arnavLogo.febc97ae.png";